class Extranet.Collections.Hotels extends Backbone.Collection
  model: Extranet.Models.GenericModel
  url: '/v2/getaways/extranet/hotels'
